// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js","948":"2cca2479"}[chunkId] || chunkId) + "-" + {"678":"c071dfb9b646583f7451","731":"9a40ccf67bf4bc3b78ae","843":"e51ea270d328b6e08060","883":"892c34be78c2a900c4ba","948":"92e4f3ae9c2902ce7987"}[chunkId] + ".js";
};